import { useSelector } from 'react-redux';
import { isServer } from 'tradera-utils/nextjs';

export const useLocation = () => {
    const request = useSelector(state => state.request);
    const location = isServer ? request.location : window.location;
    return new URL(location);
};
